var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "order-home-popup" }, [
    _c("div", { staticClass: "search-area" }, [
      _c("div", { staticClass: "search-content" }, [
        _c(
          "div",
          { staticClass: "filter-section" },
          [
            _c(
              "el-form",
              {
                staticClass: "search-form",
                attrs: { inline: true, model: _vm.searchForm },
              },
              [
                _c(
                  "el-form-item",
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入标题", clearable: "" },
                      model: {
                        value: _vm.searchForm.param,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "param", $$v)
                        },
                        expression: "searchForm.param",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "状态" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "120px" },
                        attrs: { placeholder: "全部状态", clearable: "" },
                        model: {
                          value: _vm.searchForm.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "status", $$v)
                          },
                          expression: "searchForm.status",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "未启用", value: 1 },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "已启用", value: 2 },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "未开始", value: 3 },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "进行中", value: 4 },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "已结束", value: 5 },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.handleSearch },
                      },
                      [_vm._v("搜索")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "action-section" },
          [
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.primary } },
              [_vm._v("添加弹框")]
            ),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "radio-area" },
      [
        _c(
          "el-radio-group",
          {
            attrs: { size: "small" },
            on: { change: _vm.handleTabChange },
            model: {
              value: _vm.activeTab,
              callback: function ($$v) {
                _vm.activeTab = $$v
              },
              expression: "activeTab",
            },
          },
          [
            _c("el-radio-button", { attrs: { label: "0" } }, [_vm._v("全部")]),
            _vm._v(" "),
            _c("el-radio-button", { attrs: { label: "1" } }, [
              _vm._v("NOTHING"),
            ]),
            _vm._v(" "),
            _c("el-radio-button", { attrs: { label: "2" } }, [
              _vm._v("领券弹窗"),
            ]),
            _vm._v(" "),
            _c("el-radio-button", { attrs: { label: "3" } }, [
              _vm._v("系统弹窗"),
            ]),
            _vm._v(" "),
            _c("el-radio-button", { attrs: { label: "5" } }, [
              _vm._v("调查问卷"),
            ]),
            _vm._v(" "),
            _c("el-radio-button", { attrs: { label: "6" } }, [
              _vm._v("外部小程序"),
            ]),
            _vm._v(" "),
            _c("el-radio-button", { attrs: { label: "7" } }, [
              _vm._v("微信红包封面"),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-area" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "popup-table",
            staticStyle: { width: "100%" },
            attrs: { data: _vm.tableData, border: "" },
          },
          [
            _c("el-table-column", {
              attrs: {
                type: "index",
                label: "序号",
                width: "80",
                align: "center",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "title", label: "标题", "min-width": "130px" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "div",
                        { staticClass: "title-cell" },
                        [
                          scope.row.showImage
                            ? _c(
                                "el-image",
                                {
                                  staticClass: "popup-image",
                                  attrs: {
                                    src: _vm.imagePrefix + scope.row.showImage,
                                    fit: "cover",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "image-slot",
                                      attrs: { slot: "error" },
                                      slot: "error",
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-picture-outline",
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", { staticClass: "title-text" }, [
                            _vm._v(_vm._s(scope.row.title)),
                          ]),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "recommendType",
                label: "类型",
                "min-width": "120",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            type: _vm.getTypeTagType(scope.row.recommendType),
                            size: "small",
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.getTypeText(scope.row.recommendType)) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "cdpGrpType",
                label: "分组类型",
                "min-width": "120",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            type: _vm.getCdpGrpTypeTagType(
                              scope.row.cdpGrpType
                            ),
                            size: "small",
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.getCdpGrpTypeText(scope.row.cdpGrpType)
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "recommendContent",
                label: "跳转信息",
                "min-width": "150",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.getRecommendContent(scope.row)) +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "timeRange",
                label: "展示时间",
                width: "200",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", { staticClass: "time-range" }, [
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.formatTime(scope.row.showStartTime))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(_vm._s(_vm.formatTime(scope.row.showEndTime))),
                        ]),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c(
              "el-table-column",
              {
                attrs: {
                  prop: "recommendPriority",
                  align: "center",
                  width: "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.recommendPriority)),
                        ]),
                      ]
                    },
                  },
                ]),
              },
              [
                _c("template", { slot: "header" }, [
                  _c(
                    "div",
                    { staticClass: "priority-header" },
                    [
                      _c("span", [_vm._v("优先级")]),
                      _vm._v(" "),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: "优先展示优先级高的",
                            placement: "top",
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-question priority-help-icon",
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              2
            ),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "isEnable",
                label: "是否启用",
                width: "100",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("el-switch", {
                        attrs: { "active-color": "#13ce66" },
                        on: {
                          change: function ($event) {
                            return _vm.handleStatusChange(scope.row)
                          },
                        },
                        model: {
                          value: scope.row.isEnable,
                          callback: function ($$v) {
                            _vm.$set(scope.row, "isEnable", $$v)
                          },
                          expression: "scope.row.isEnable",
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "isShow",
                label: "是否展示",
                width: "100",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("el-switch", {
                        attrs: { "active-color": "#13ce66" },
                        on: {
                          change: function ($event) {
                            return _vm.handleShowChange(scope.row)
                          },
                        },
                        model: {
                          value: scope.row.isShow,
                          callback: function ($$v) {
                            _vm.$set(scope.row, "isShow", $$v)
                          },
                          expression: "scope.row.isShow",
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "操作",
                align: "center",
                fixed: "right",
                width: "200",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.handleCopy(scope.row)
                            },
                          },
                        },
                        [_vm._v("复制")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.handleEdit(scope.row)
                            },
                          },
                        },
                        [_vm._v("编辑")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "danger", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.handleDelete(scope.row)
                            },
                          },
                        },
                        [_vm._v("移除")]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "pagination-area" },
      [
        _c("el-pagination", {
          attrs: {
            "current-page": _vm.searchForm.page,
            "page-sizes": [10, 20, 30, 50],
            "page-size": _vm.searchForm.limit,
            layout: "total, sizes, prev, pager, next, jumper",
            total: _vm.searchForm.total,
          },
          on: {
            "size-change": _vm.handleSizeChange,
            "current-change": _vm.handleCurrentChange,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }